import React from 'react'
import classNames from 'classnames'
import Sprite from '~components/Sprite'
import Link from '~components/Link'
import * as Styles from '~styles/components/social.module.scss'

const Social = (props) => {
  return (
    <div className={Styles.social}>
      <Link
        href="https://x.com/lcymediasales"
        aria-label="X"
        className={classNames(Styles.socialItem, 'icon iconSm')}
        track={{
          category: 'X',
          action: 'Follow',
          label: 'https://x.com/lcymediasales'
        }}
      >
        <Sprite name="x" />
      </Link>

      <Link
        href="https://www.linkedin.com/in/london-city-airport-media-sales-568a8017a/"
        aria-label="LinkedIn"
        className={classNames(Styles.socialItem, 'icon iconSm')}
        track={{
          category: 'LinkedIn',
          action: 'Follow',
          label: 'https://www.linkedin.com/company/lcymediasales'
        }}
      >
        <Sprite name="linkedin" />
      </Link>

      <Link
        href="https://www.facebook.com/LondonCityAir/"
        aria-label="Facebook"
        className={classNames(Styles.socialItem, 'icon iconSm')}
        track={{
          category: 'Facebook',
          action: 'Follow',
          label: 'https://www.facebook.com/LondonCityAir/'
        }}
      >
        <Sprite name="facebook" />
      </Link>
    </div>
  )
}

export default Social
